import { Outlet } from 'react-router-dom';

export const AdminLogs = () => {
  return <Outlet />;
};

export default AdminLogs;
